import API from 'src/api'
import { http } from '../boot/axios'

function buildSubLocationsBody (payload) {
  const isObj = typeof payload === 'object' && payload !== null
  const id = isObj ? payload.id : payload
  const locations = isObj ? payload.locations : []
  const body = Array.isArray(locations) && locations.length > 0 ? { locations } : {}
  return { id, body }
}

export default {
  URL: API.URL,
  GRAPHQL_URL: `${API.GRAPHQL_URL}`,
  createNewFolder (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folders/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  createNewSubFolder (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}subFolders/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  all () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}folders/all`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  subFolderEdit (id) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}subFolderEdit/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  subFolderShow (id) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}subFolderShow/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  subFolderName (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}subFolderName/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateSubGroup (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}updateSubGroup/${payload.id}`, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  byId (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}folder/${payload.id}`, { params: {
        locations: payload.locations
      }})
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderbyApprovedRejected (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderbyApprovedRejected/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdUpload (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdUpload/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdCurrent (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdCurrent/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdExpired (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdExpired/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdProcess (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdProcess/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdExpirationDate (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdExpirationDate/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  byRolLocation (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}folderByLocationRol/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  byRolLocationUpload (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByLocationRolUpload/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  byRolLocationCurrent (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByLocationRolCurrent/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  byRolLocationExpired (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByLocationRolExpired/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  byRolLocationProcess (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByLocationRolProcess/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  byRolLocationExpirationDate (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByRolLocationExpirationDate/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  byRolLocationDates (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}byRolLocationDates/${payload.folder_id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderLocationList (id) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}subFolderLocations/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}folder/${id}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  update (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}folder/${payload.id}`, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  byRol (payload) {
    const upload = new FormData()
    upload.append('roles', payload.rolesArray)
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folders/folderByRol`, upload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  subFolderList (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}subFoldersList/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getSubLocations (payload) {
    const { id, body } = buildSubLocationsBody(payload)
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}getSubLocations/${id}`, body)
        .then(res => { resolve(res.data) })
        .catch(error => { reject(error) })
    })
  },
  getSubLocationsResponsible (payload) {
    const { id, body } = buildSubLocationsBody(payload)
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}getSubLocationsResponsible/${id}`, body)
        .then(res => { resolve(res.data) })
        .catch(error => { reject(error) })
    })
  },
  getSubLocationsSupervisor (payload) {
    const { id, body } = buildSubLocationsBody(payload)
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}getSubLocationsSupervisor/${id}`, body)
        .then(res => { resolve(res.data) })
        .catch(error => { reject(error) })
    })
  },
  getSubLocationsApprover (payload) {
    const { id, body } = buildSubLocationsBody(payload)
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}getSubLocationsApprover/${id}`, body)
        .then(res => { resolve(res.data) })
        .catch(error => { reject(error) })
    })
  },
  folderByIdUploadResponsible (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdUploadResponsible/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdCurrentResponsible (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdCurrentResponsible/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdExpiredResponsible (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdExpiredResponsible/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdUploadSupervisor (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdUploadSupervisor/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdCurrentSupervisor (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdCurrentSupervisor/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdExpiredSupervisor (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdExpiredSupervisor/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  folderByIdUploadApprover (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdUploadApprover/${payload.id}`, payload)
        .then(res => { resolve(res.data) })
        .catch(error => { reject(error) })
    })
  },
  folderByIdCurrentApprover (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdCurrentApprover/${payload.id}`, payload)
        .then(res => { resolve(res.data) })
        .catch(error => { reject(error) })
    })
  },
  folderByIdExpiredApprover (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}folderByIdExpiredApprover/${payload.id}`, payload)
        .then(res => { resolve(res.data) })
        .catch(error => { reject(error) })
    })
  }
}
